import Rule from "./ruleV2";

export class AccessGroup {
	constructor({
		id,
		name,
		rules,
		accessGroupRightCount = null,
		stats = null
	} = {}) {
		this.id = id;
		this.name = name;
		this.rules = rules || [];
		this.accessGroupRightCount = accessGroupRightCount || 0;
		this.stats = stats;
	}

	static buildFromJSON(json) {
		return new AccessGroup({
			id: json.id,
			name: json.name,
			color: json.color,
			rules: json.rules?.map(ruleJson => Rule.buildFromJSON(ruleJson)),
			accessGroupRightCount: json.access_group_right_count, // Will be depracated
			stats: json.stats
		});
	}

	toJSON() {
		return {
			id: this.id,
			name: this.name,
			rules: this.rules.map(rule => rule.toJSON())
		};
	}

	getId() {
		return this.id;
	}

	getName() {
		return this.name;
	}

	getRules() {
		return this.rules;
	}
	getAccessGroupRightCount() {
		return this.accessGroupRightCount;
	}

	getGroupedRules() {
		return this.rules.reduce((acc, rule) => {
			const groupKey = rule.getGroupedKey();

			if (!acc[groupKey]) {
				return {
					...acc,
					[groupKey]: [rule]
				};
			}

			return {
				...acc,
				[groupKey]: [...acc[groupKey], rule]
			};
		}, {});
	}

	hasRules() {
		return this.rules.length > 0;
	}

	/**
	 * Remove a  category from rules
	 * @param {number} categoryId - ID of category to remove
	 * @returns {AccessGroup} New instance with updated rules
	 */
	removeCategory(categoryId) {
		return new AccessGroup(
			this.id,
			this.name,
			this.rules.filter(rule => rule.rate_category?.id !== categoryId)
		);
	}

	/**
	 * Remove a rate from rules
	 * @param {number} rateId - ID of rate to remove
	 * @returns {AccessGroup} New instance with updated rules
	 */
	removeRate(rateId) {
		return new AccessGroup(
			this.id,
			this.name,
			this.rules.filter(rule => rule.rate?.id !== rateId)
		);
	}
}
